import { PaginatorResponse } from "src/app/modules/utils/model/pages-and-components.config";

export class PaymentOrder{
  id: string;
  clientId: string;
  registerDate: string;
  status: string;
  origin: string;
  registrationBoUserId: string;
  projectId: string;
  paymentCode: string;
  currency: string;
  amount: number;
  dueDate: string;
  campaignCode: string;
  campaignAmount: number;
  campaignExpirationDate: string;
  productName: string;
  interests: number;
  balance: number;
  quota : number;
  attachment1: Attachment | null;
  attachment2: Attachment | null;
  issuedDate: string;
  description: string;
  discount: number;
  externalOrderId: string;
  runVerification: boolean;
  situation: string;
  daysPaidAfterDueDate: number;
  paymentOrderType : string;
  paidAmount: number;
  subscriptionPaymentStatus : string;
}

export class Attachment{
  url:string;
  originalFilename:string;
  size:number;
  checksum:string;
}

export class PaymentOrderWithSelector extends PaymentOrder{
  selected? : boolean;
  clientDocumentType? : number;
  clientDocumentNumber? : string;
}

export class PaymentOrderCreateDTO{
  documentTypeId: number;
  documentNumber: string;
  origin: string;
  paymentCode: string;
  amount: number;
  dueDate: string;
  productName: string;
  interests: number;
  balance: number;
  externalClientId: string;
  quota : number;
  currency : string;
  attachment1: Attachment | null;
  attachment2: Attachment | null;
  issuedDate: string;
  description: string;
  discount: number;
  externalOrderId: string;
  runVerification: boolean;
  paymentOrderType : string;
  subscriptionEnabled : boolean;
  subscriptionType : string;
}

export class PaymentOrderUpdateDTO{
  id: string;
  registrationBoUserId: string;
  paymentCode: string;
  projectId: string;
  amount: number;
  dueDate: string;
  productName: string;
  interests: number;
  balance: number;
  quota : number;
  currency : string;
  attachment1: Attachment | null;
  attachment2: Attachment | null;
  issuedDate: string;
  description: string;
  discount: number;
  externalOrderId: string;
  runVerification: boolean;
  writeOff: boolean | null;
  paymentOrderType : string;
  subscriptionEnabled : boolean;
  subscriptionType : string;
}

export class AnnulmentPaymentOrdersBatchRequest{
  paymentOrderIds: string[];
  type? : string;
}

export class RevertAnnulmentPaymentOrdersBatchRequest{
  paymentOrderIds: string[];
  type? : string;
}

export enum StatusPaymentOrder{
  PENDING_STATUS = 'P',
  PAYED_STATUS = 'F',
  ANNULLED_STATUS = 'A',
  STATUS_SHOW_MORE_CONVERSATIONS = 'SMC',
  INACTIVE_STATUS = 'I',
  WRITE_OFF_STATUS = 'R'
}

export class PaymentOrderBalance{
  balance : number;
  currency : string;
}

export class PaymentOrderAmount{
  currency : string;
  data:PaymentOrderTotals;
}

export class PaymentOrderTotals{
  amount : number;
  balance : number;
  interests : number;
  discount : number;
  creditCapital: number;
  creditFees: number;
  creditOtherCharges: number;
  paidAmount: number;
}

export class PaymentOrderPortfolioTotalProject{
  currency : string;
  totalAmount : number;
  debtBalance : number;
  currentBalance : number;
  expiredBalance : number;
}

export class PaymentOrderListFilterPageable extends PaginatorResponse {
    content : PaymentOrderListFilter[];
}

export class PaymentOrderListFilter{
  id: string;
  status: string;
  paymentCode: string;
  quota: number;
}

export class DistinctProductPageableData extends PaginatorResponse {
    content : string[];
}

export class DistinctTradeNamesPageableData extends PaginatorResponse {
    content : string[];
}

export enum CalculationType {
  GERMAN_CALCULATION_TYPE = 'G',
  FRENCH_CALCULATION_TYPE = 'F',
  BALLOON_CALCULATION_TYPE = 'B',
  DIRECT_CALCULATION_TYPE = 'D',
}

export enum Frequency {
  MONTHLY_FREQUENCY = 'M',
  WEEKLY_FREQUENCY = 'W',
  BIWEEKLY_FREQUENCY = 'B',
  QUARTERLY_FREQUENCY = 'Q',
  SEMIANNUAL_FREQUENCY = 'H'
}

export enum PaymentOrderSituation {
  OVERDUE_SITUATION = "O",
  PARTIALLY_PAID_SITUATION = "W",
  PAID_AFTER_DUE_DATE_SITUATION = "D",
  CLAIM_SITUATION = "C"
}

export enum PaymentOrderType {
  PAYMENT_ORDER = 'P',
  UNAPPLIED_PAYMENTS = 'U',
  CUSTOMER_ADVANCES = 'A',
}

export enum SubscriptionStatus{
  PENDING = 'P',
  RETRYING = 'R',
  COLLECTED = 'S',
  FAILED = 'F',
  MANUAL = 'M'
}
